(() => {
  const main = document.querySelector('#main');
  const concierge = document.querySelector('.mojo-wa');
  if (!main?.querySelector('.mojo-sleep-compact--home') || !concierge || concierge.dataset.homeGuardReady) return;
  concierge.dataset.homeGuardReady = 'true';
  let pending = false;

  const visible = (element) => {
    const style = getComputedStyle(element);
    return style.visibility === 'visible' && style.display !== 'none' && Number(style.opacity) !== 0 && !element.closest('[inert],[hidden]');
  };

  const update = () => {
    pending = false;
    if (concierge.contains(document.activeElement)) {
      concierge.removeAttribute('data-home-obscured');
      return;
    }
    const focusedForm = main.contains(document.activeElement) && document.activeElement.matches('input,select,textarea');
    const modalOpen = !!document.querySelector('dialog[open],header-sidebar[open],cart-drawer[open],newsletter-popup[open],quick-buy-modal[open]');
    const area = concierge.getBoundingClientRect();
    const controls = [...main.querySelectorAll('a[href],button,input,select,textarea,summary,video[controls],[role="button"]'), ...document.querySelectorAll('#shop-hcaptcha-badge-container')];
    const collision = controls.some((element) => {
      const bounds = element.getBoundingClientRect();
      if (!bounds.width || !bounds.height || bounds.bottom < area.top - 8 || bounds.top > area.bottom + 8 || bounds.right < area.left - 8 || bounds.left > area.right + 8) return false;
      return visible(element);
    });
    concierge.toggleAttribute('data-home-obscured', focusedForm || modalOpen || collision);
  };

  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  const resize = new ResizeObserver(schedule);
  resize.observe(main);
  resize.observe(concierge);
  const badgeId = 'shop-hcaptcha-badge-container';
  let badges = [];
  const badgeObserver = new MutationObserver((changes) => {
    if (changes.some((change) => change.target.id === badgeId && document.body.contains(change.target))) schedule();
  });
  const refreshBadges = () => {
    const next = [...document.querySelectorAll('#' + badgeId)];
    if (next.length === badges.length && next.every((badge, index) => badge === badges[index])) return;
    badgeObserver.disconnect();
    badges = next;
    badges.forEach((badge) => badgeObserver.observe(badge, { attributes: true, attributeFilter: ['style', 'class'] }));
  };
  refreshBadges();
  new MutationObserver((changes) => {
    const membershipChanged = changes.some((change) => change.type === 'childList' || (change.attributeName === 'id' && (change.oldValue === badgeId || change.target.id === badgeId)));
    if (membershipChanged) refreshBadges();
    if (changes.some((change) => change.type === 'childList' || ['open', 'hidden', 'inert'].includes(change.attributeName) || (change.attributeName === 'id' && (change.oldValue === badgeId || change.target.id === badgeId)))) schedule();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeOldValue: true, attributeFilter: ['open', 'hidden', 'inert', 'id'] });
  schedule();
})();

